
/* @ngInject */
function ProfileNotificationsController ($scope, $state, $rootScope, UserService, ToastService, SegmentService) {
  $scope.$parent.selectedMenuId = $state.current.data.selectedMenuId

  const api = {
    _successGetNotificationsConfig,
    _errorGetNotificationsConfig,
    _applyCheckboxValues,
    _successUpdateNotifications
  }
  this.getApi = () => api

  activate()

  function activate () {
    UserService.getUserNotificationsConfig().then(api._successGetNotificationsConfig).catch(api._errorGetNotificationsConfig)

    $rootScope.getCompanyFeaturesAndAddons().then(({ features }) => {
      $scope.features = features
    })
  }

  $scope.updateNotificationConfig = (e) => {
    const types = {
      arts: 'ART_APPROVALS',
      newRequests: 'NEW_REQUESTS',
      assignedTasks: 'ASSIGNED_TASKS',
      unassignedTasks: 'UNASSIGNED_TASKS',
      posts: 'NEW_POSTS',
      checklists: 'CHECKLISTS',
      users: 'NEW_USERS',
      analytics: 'AUTOMATIC_ANALYTICS_REPORT'
    }

    const configInfo = e.detail.name.split('-')
    const updateInfo = {
      type: types[configInfo[0]] ? types[configInfo[0]] : '',
      emailValue: undefined,
      deskfyValue: undefined,
      mobileValue: undefined
    }

    if (configInfo[1] === 'email') {
      updateInfo.emailValue = e.detail.value
    } else if (configInfo[1] === 'deskfy') {
      updateInfo.deskfyValue = e.detail.value
    } else if (configInfo[1] === 'mobile') {
      updateInfo.mobileValue = e.detail.value
    }

    UserService.updateUserNotificationsConfig(updateInfo)
      .then(() => api._successUpdateNotifications(updateInfo))
      .catch(api._errorGetNotificationsConfig)
  }

  function _successGetNotificationsConfig (results) {
    results.forEach(config => {
      api._applyCheckboxValues(config)
    })
  }

  function _errorGetNotificationsConfig () {
    ToastService.defaultErrorToast()
  }

  function _successUpdateNotifications (info) {
    let channel = ''
    let value
    if (info.deskfyValue !== undefined) {
      channel = 'desktop'
      value = info.deskfyValue
    } else if (info.emailValue !== undefined) {
      channel = 'email'
      value = info.emailValue
    } else if (info.mobileValue !== undefined) {
      channel = 'app'
      value = info.mobileValue
    }

    SegmentService.track('user-config-notification', {
      config_notification: info.type,
      value,
      channel
    })
  }

  function _applyCheckboxValues (config) {
    const names = {
      ART_APPROVALS: 'arts-',
      NEW_REQUESTS: 'newRequests-',
      ASSIGNED_TASKS: 'assignedTasks-',
      UNASSIGNED_TASKS: 'unassignedTasks-',
      NEW_POSTS: 'posts-',
      CHECKLISTS: 'checklists-',
      NEW_USERS: 'users-',
      AUTOMATIC_ANALYTICS_REPORT: 'analytics-'
    }

    const checkoxSubName = names[config.type]

    if (checkoxSubName) {
      const emailCheckbox = $(`.profile-notifications-page uds-checkbox[name="${checkoxSubName + 'email'}"]`)
      const deskfyCheckbox = $(`.profile-notifications-page uds-checkbox[name="${checkoxSubName + 'deskfy'}"]`)

      if (config.emailValue) {
        emailCheckbox.attr('checked', true)
      }

      if (config.deskfyValue) {
        deskfyCheckbox.attr('checked', true)
      }
    }
  }
}

export { ProfileNotificationsController }
